module.exports = __webpack_public_path__ + "static/media/navbar-ico-2.10bbb91d.svg";